/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Form_Email_AriaInputs */

const en_form_email_aria = /** @type {(inputs: Form_Email_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your email address`)
};

const ar_form_email_aria = /** @type {(inputs: Form_Email_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`عنوان بريدك الإلكتروني`)
};

const bn_form_email_aria = /** @type {(inputs: Form_Email_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`আপনার ইমেইল ঠিকানা`)
};

const de_form_email_aria = /** @type {(inputs: Form_Email_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ihre E-Mail-Adresse`)
};

const es_form_email_aria = /** @type {(inputs: Form_Email_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tu dirección de correo electrónico`)
};

const fr_form_email_aria = /** @type {(inputs: Form_Email_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Votre adresse e-mail`)
};

const pt_form_email_aria = /** @type {(inputs: Form_Email_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seu endereço de e-mail`)
};

const zh_form_email_aria = /** @type {(inputs: Form_Email_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`您的电子邮件地址`)
};

const tr_form_email_aria = /** @type {(inputs: Form_Email_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-posta adresiniz`)
};

const ru_form_email_aria = /** @type {(inputs: Form_Email_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ваш адрес электронной почты`)
};

const pl_form_email_aria = /** @type {(inputs: Form_Email_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Twój adres e-mail`)
};

/**
* | output |
* | --- |
* | "Your email address" |
*
* @param {Form_Email_AriaInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const form_email_aria = /** @type {((inputs?: Form_Email_AriaInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Form_Email_AriaInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_form_email_aria(inputs)
	if (locale === "bn") return bn_form_email_aria(inputs)
	if (locale === "de") return de_form_email_aria(inputs)
	if (locale === "es") return es_form_email_aria(inputs)
	if (locale === "fr") return fr_form_email_aria(inputs)
	if (locale === "pt") return pt_form_email_aria(inputs)
	if (locale === "zh") return zh_form_email_aria(inputs)
	if (locale === "tr") return tr_form_email_aria(inputs)
	if (locale === "ru") return ru_form_email_aria(inputs)
	if (locale === "pl") return pl_form_email_aria(inputs)
	return en_form_email_aria(inputs)
});